export default __webpack_public_path__ + "static/media/sad.227ce7cd.png";